import React from 'react'
// import mous from "../../assets/images/ss-mous.jpg";
// import { Link } from "react-router-dom";
// import icon_image from "../../assets/Icon-2.gif"
// import icon_image1 from "../../assets/Icon-3.gif"
import icon_image2 from "../../assets/Icon-7.gif"

const QualityPolicy = () => {
  return (
    <div style={{paddingTop:"40px"}}>
            <div className="Home-boxes3" style={{width:"50%",margin:"auto",}} >
          <img src={icon_image2} height={"100px"} width={"100px"}></img>
            <h5 className="mb-1 mt-2">Quality Policy</h5>
            <p style={{ textAlign: "center", padding:"12px" }}>
                  To provide an industry need education through high quality
                  knowledge transfer with excellent skills at par with
                  international standards to get good placements.
                </p>
          </div>
    </div>
  )
}

export default QualityPolicy
